import ContentCard from './ContentCard'
import style from './style.module.scss'
import { Props } from './types'

function CuratedContentList({ headlineText, contentItems }: Props) {
  return (
    <div className={style.container}>
      {contentItems?.map((item) => (
        <ContentCard item={item} key={item.headlineText} />
      ))}
    </div>
  )
}

export default CuratedContentList
